interface Failure {
  message: string;
}

export const GetAllProjectFailure: Failure = {
  message: "Failed to get all projects",
};
